import { DownloadOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { FC } from 'react';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';

type ReportDownloadsProps = {
  fileName: string;
  headers: { key: string; label: string }[];
  data: Record<string, string | number | boolean>[];
};

export const ReportDownloads: FC<ReportDownloadsProps> = ({
  fileName,
  headers,
  data,
}) => {
  const { t } = useTranslation('reports.ReportDownloads');
  const isEmpty = data.length === 0;

  const handleExcelDownload = () => {
    const sheetRows = [
      headers.map(({ label }) => label),
      ...data.map((row) => headers.map(({ key }) => row[key] ?? '')),
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <Space size="middle">
      {isEmpty ? (
        <Button icon={<DownloadOutlined />} disabled>
          {t('downloadCsv')}
        </Button>
      ) : (
        <CSVLink headers={headers} data={data} filename={fileName}>
          <Button icon={<DownloadOutlined />}>{t('downloadCsv')}</Button>
        </CSVLink>
      )}
      <Button
        icon={<DownloadOutlined />}
        disabled={isEmpty}
        onClick={handleExcelDownload}
      >
        {t('downloadExcel')}
      </Button>
    </Space>
  );
};
